import { CALL_API } from "admin/middlewares/api";

export const CREATE_SAVELEND_SPECIAL_ACCOUNT_WITHDRAWAL_ORDER_REQUEST =
  "CREATE_SAVELEND_SPECIAL_ACCOUNT_ORDER_REQUEST";
export const CREATE_SAVELEND_SPECIAL_ACCOUNT_WITHDRAWAL_ORDER_SUCCESS =
  "CREATE_SAVELEND_SPECIAL_ACCOUNT_ORDER_SUCCESS";
export const CREATE_SAVELEND_SPECIAL_ACCOUNT_WITHDRAWAL_ORDER_ERROR =
  "CREATE_SAVELEND_SPECIAL_ACCOUNT_ORDER_ERROR";

export function create_savelend_account_withdrawal_order(
  Account,
  Currency,
  Amount,
  Notes,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/create-special-account-withdrawal-order",
      authenticatedRequest: true,
      data: { Account, Currency, Amount, Notes },
      method: "POST",
      types: [
        CREATE_SAVELEND_SPECIAL_ACCOUNT_WITHDRAWAL_ORDER_REQUEST,
        {
          method: accountSpecialOrdersChanged.bind(
            this,
            CREATE_SAVELEND_SPECIAL_ACCOUNT_WITHDRAWAL_ORDER_SUCCESS,
          ),
        },
        CREATE_SAVELEND_SPECIAL_ACCOUNT_WITHDRAWAL_ORDER_ERROR,
      ],
    },
  };
}

export const CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_REQUEST =
  "CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_REQUEST";
export const CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_SUCCESS =
  "CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_SUCCESS";
export const CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_ERROR =
  "CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_ERROR";

export function create_savelend_account_deposit_order(
  Account,
  Currency,
  Amount,
  Notes,
) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/create-special-account-deposit-order",
      authenticatedRequest: true,
      data: { Account, Currency, Amount, Notes },
      method: "POST",
      types: [
        CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_REQUEST,
        {
          method: accountSpecialOrdersChanged.bind(
            this,
            CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_SUCCESS,
          ),
        },
        CREATE_SAVELEND_SPECIAL_ACCOUNT_DEPOSIT_ORDER_ERROR,
      ],
    },
  };
}

export const GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_REQUEST =
  "GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_REQUEST";
export const GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_SUCCESS =
  "GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_SUCCESS";
export const GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_ERROR =
  "GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_ERROR";

export function get_savelend_special_account_orders() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/special-account-transaction-orders",
      authenticatedRequest: true,
      method: "GET",
      types: [
        GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_REQUEST,
        GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_SUCCESS,
        GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_ERROR,
      ],
    },
  };
}

export const CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_REQUEST =
  "CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_REQUEST";
export const CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_SUCCESS =
  "CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_SUCCESS";
export const CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_ERROR =
  "CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_ERROR";

export function confirm_savelend_special_account_order(Id) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/confirm-special-account-transaction-order",
      authenticatedRequest: true,
      data: { Id },
      method: "POST",
      types: [
        CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_REQUEST,
        {
          method: accountSpecialOrdersChanged.bind(
            this,
            CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_SUCCESS,
          ),
        },
        CONFIRM_SAVELEND_SPECIAL_ACCOUNT_ORDER_ERROR,
      ],
    },
  };
}

export const CANCEL_SEND_BACK_ORDER_REQUEST = "CANCEL_SEND_BACK_ORDER_REQUEST";
export const CANCEL_SEND_BACK_ORDER_SUCCESS = "CANCEL_SEND_BACK_ORDER_SUCCESS";
export const CANCEL_SEND_BACK_ORDER_ERROR = "CANCEL_SEND_BACK_ORDER_ERROR";
export function cancel_savelend_special_account_order(Id) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/cancel-special-account-transaction-order",
      authenticatedRequest: true,
      data: { Id },
      method: "POST",
      types: [
        CANCEL_SEND_BACK_ORDER_REQUEST,
        {
          method: accountSpecialOrdersChanged.bind(
            this,
            CANCEL_SEND_BACK_ORDER_SUCCESS,
          ),
        },
        CANCEL_SEND_BACK_ORDER_ERROR,
      ],
    },
  };
}

function accountSpecialOrdersChanged(type, response) {
  return (dispatch) => {
    dispatch({
      type,
      response,
    });
    dispatch(get_savelend_special_account_orders());
  };
}
